module.exports = __webpack_public_path__ + "img/1525255803.6f9e9c65.jpg";